type GAEventParams = Record<string, string | number | boolean>;

const trackGAEvent = (eventName: string, eventParams?: GAEventParams) => {
  try {
    if (typeof window === 'undefined') return;
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    const event = {
      event: eventName,
      eventModel: {
        ...eventParams,
      },
    };
    window.dataLayer.push(event);
  } catch (error) {
    // @todo: кастомные ошибки Sentry
    if (process.env.NODE_ENV === 'development') {
      console.error('Error tracking GA event:', error);
    }
  }
};

export type { GAEventParams };
export { trackGAEvent };
